import dayjs from 'dayjs';

const DAYS_OF_WEEK = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']

export default [
    {
        field: 'id',
        headerName: 'Código',
        width: 80
    },
    {
        field: 'title',
        headerName: 'Título',
        width: 220,
        valueGetter: (params) => params?.row.title || ''
    },
    {
        field: 'description',
        headerName: 'Mensagem',
        width: 260,
        valueGetter: (params) => params?.row.description || ''
    },
    {
        field: 'schedule_type',
        headerName: 'Tipo',
        width: 120,
        valueGetter: (params) => params?.row?.schedule_type === 'weekly' ? 'Semanal' : 'Data específica'
    },
    {
        field: 'schedule_info',
        headerName: 'Agendamento',
        width: 200,
        valueGetter: (params) => {
            const row = params?.row
            if (!row) return '-'
            if (row.schedule_type === 'weekly') {
                const day = DAYS_OF_WEEK[row.day_of_week] ?? '-'
                return `${day} às ${row.scheduled_time}`
            }
            if (row.schedule_type === 'specific') {
                const date = row.specific_date ? dayjs(row.specific_date).format('DD/MM/YYYY') : '-'
                return `${date} às ${row.scheduled_time}`
            }
            return '-'
        }
    },
    {
        field: 'user_ids',
        headerName: 'Destinatários',
        width: 200,
        valueGetter: (params) => {
            const ids = params?.row?.user_ids
            if (!ids || ids.length === 0) return 'Todos os usuários'
            return `${ids.length} usuário(s) específico(s)`
        }
    },
    {
        field: 'is_active',
        headerName: 'Ativo',
        width: 100,
        valueGetter: (params) => params?.row?.is_active ? 'Sim' : 'Não'
    },
    {
        field: 'last_sent_at',
        headerName: 'Último disparo',
        width: 160,
        valueFormatter: (params) => params.value ? dayjs(params.value).format('DD/MM/YYYY HH:mm') : 'Nunca'
    },
]
